<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form :inline="true" label-suffix=":" :label-position="`left`" :size="size" @submit.native.prevent>
        <el-row>
          <el-col :md="14">
            <PeriodFormItem v-model="searchForm" />
          </el-col>

          <el-col :md="8">
            <el-form-item :label="$t('유형')">
              <el-radio-group v-model="searchForm.periodTp">
                <el-radio-button :label="$t('결제수단')"></el-radio-button>
                <el-radio-button :label="$t('주문유형')"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('StatisticsMenuSearch')"
        :size="size"
        @click="search"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <!--			<el-button v-if="checkAuthActionAccess('StatisticsMenuSearch')" :size="size"  @click="chart" icon="el-icon-picture-outline" >{{ $t('그래프 보기') }}</el-button>-->
      <el-button :size="size" @click="downloadExcel" icon="el-icon-download">{{ $t('엑셀 다운') }}</el-button>
      <SalesBasisInfo basis="net" class="basis-inline" />
    </div>

    <!-- 리스트 -->
    <el-table
      v-if="'orderTp' == searchForm.periodTpVal"
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      show-summary
      :summary-method="getSummaries">
      <el-table-column
        :label="$t('기간')"
        prop="date"
        min-width="100"
        align="center"
        sortable
        label-class-name="data_cnt"></el-table-column>
      <el-table-column
        :label="$t('포스 주문')"
        prop="pos"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('키오스크 주문')"
        prop="kiosk"
        min-width="120"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('테이블 주문')"
        prop="table"
        min-width="130"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('전화 주문')"
        prop="telephone"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('배달앱 주문')"
        prop="deliveryApp"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('파트너 주문')"
        prop="partner"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('모바일 테이블 주문')"
        prop="mobileTable"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('기타')"
        prop="etc"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('합계')"
        prop="sum"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
    </el-table>

    <el-table
      v-if="'salesTp' == searchForm.periodTpVal"
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      show-summary
      :summary-method="getSummaries">
      <el-table-column
        :label="$t('기간')"
        prop="date"
        min-width="100"
        align="center"
        sortable
        label-class-name="data_cnt"></el-table-column>
      <el-table-column
        :label="$t('현금')"
        prop="cash"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('카드')"
        prop="card"
        min-width="120"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('포인트')"
        prop="point"
        min-width="130"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('간편결제')"
        prop="easy"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('온라인결제')"
        prop="online"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('기타')"
        prop="etc"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('합계')"
        prop="sum"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import PeriodFormItem from '@/components/statistics/PeriodFormItem.vue'
import SalesBasisInfo from '@/components/SalesBasisInfo.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { statisticsAxisRange } from '@/utils/periodFilter'

export default {
  mixins: [mainVueMixin],

  components: { PeriodFormItem, SalesBasisInfo },

  data: function () {
    var data = initData()
    data.url = '/statistics/pay'
    data.searchForm = this.initSearchForm()

    // data.dialogChartVisible = false;

    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    // 분류 선택 이벤트 — 고른 축의 기본 기간은 `utils/periodFilter` 의 `statisticsAxisRange` 한 곳이 셈한다(KST 달력)
    'searchForm.dateSearchTp': function (newVal) {
      if (this.$t('시간별') == newVal) {
        this.searchForm.dateSearchTpVal = 'HOUR'
      } else if (this.$t('일별') == newVal) {
        this.searchForm.dateSearchTpVal = 'DAY'
      } else if (this.$t('월별') == newVal) {
        this.searchForm.dateSearchTpVal = 'MONTH'
      } else if (this.$t('년별') == newVal) {
        this.searchForm.dateSearchTpVal = 'YEAR'
      }
      Object.assign(this.searchForm, statisticsAxisRange(this.searchForm.dateSearchTpVal, Date.now()))
      this.search()
    },

    // 분류 선택 이벤트
    'searchForm.periodTp': function (newVal) {
      if (this.$t('결제수단') == newVal) {
        this.searchForm.periodTpVal = 'salesTp'
      } else if (this.$t('주문유형') == newVal) {
        this.searchForm.periodTpVal = 'orderTp'
      }

      this.search()
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        dateSearchTp: this.$t('일별'),
        // dateSearchTpVal: 't',
        dateSearchTpVal: 'DAY',
        // seDt: [util.getDate('yyyy-MM-dd HH:mm', util.dateAdd('HOUR ', -2, new Date())), util.getNow('yyyy-MM-dd HH:mm')], // 시간별
        seDt: [util.getDate('yyyy-MM-dd', util.dateAdd('w ', -1, new Date())), util.getNow('yyyy-MM-dd')], // 일별
        startDt: '',
        endDt: '',
        periodTp: this.$t('결제수단'),
        periodTpVal: 'salesTp',
      }
    },
    // 조회
    search: function () {
      var startDate = ''
      var endDate = ''
      // 년 일때는 설정 안해줌
      if ('DAY' == this.searchForm.dateSearchTpVal) {
        if (null == this.searchForm.seDt || this.searchForm.seDt.length < 2) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        this.searchForm.startDt = this.searchForm.seDt[0]
        this.searchForm.endDt = this.searchForm.seDt[1]
        startDate = this.searchForm.startDt
        endDate = this.searchForm.endDt
      } else if ('MONTH' == this.searchForm.dateSearchTpVal) {
        if (null == this.searchForm.seDt || this.searchForm.seDt.length < 2) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        this.searchForm.startDt = this.searchForm.seDt[0]
        this.searchForm.endDt = this.searchForm.seDt[1]

        const year = this.searchForm.endDt.substring(0, 4)
        const month = this.searchForm.endDt.substring(5, 7)
        const lastDay = new Date(year, month, 0).getDate()

        startDate = this.searchForm.startDt + '-01'
        endDate = this.searchForm.endDt + '-' + lastDay
      } else if ('YEAR' == this.searchForm.dateSearchTpVal) {
        if (util.isEmpty(this.searchForm.startDt) || util.isEmpty(this.searchForm.endDt)) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        startDate = this.searchForm.startDt + '-01-01'
        endDate = this.searchForm.endDt + '-12-31'
      }

      var param = {
        axisType: this.searchForm.dateSearchTpVal,
        startDate: startDate,
        endDate: endDate,
        type: this.searchForm.periodTpVal,
      }

      this.mainVue.$axios.search(
        this.url,
        param,
        function (result) {
          let statistics = []

          const periods = result.periods

          if (param.type === 'salesTp') {
            periods.forEach(function (period) {
              const types = period.types
              let cash
              let card
              let point
              let easy
              let online
              let etc
              let sum = 0

              types.forEach(function (type) {
                let tp = type.type
                if (tp === 'CASH') {
                  cash = type.amount
                }
                if (tp === 'CARD') {
                  card = type.amount
                }
                if (tp === 'POINT') {
                  point = type.amount
                }
                if (tp === 'EASY') {
                  easy = type.amount
                }
                if (tp === 'ONLINE') {
                  online = type.amount
                }
                if (tp === 'ETC') {
                  etc = type.amount
                }
                if (tp !== 'POINT') {
                  sum += type.amount
                }
              })

              statistics.push({
                date: period.date,
                cash: cash,
                card: card,
                point: point,
                easy: easy,
                online: online,
                etc: etc,
                sum: sum,
              })
            })
          }

          if (param.type === 'orderTp') {
            periods.forEach(function (period) {
              const types = period.types

              let pos
              let kiosk
              let table
              let telephone
              let deliveryApp
              let partner
              let mobileTable
              let etc
              let sum = 0

              types.forEach(function (type) {
                let tp = type.type
                if (tp === 'POS_ORDER') {
                  pos = type.amount
                }
                if (tp === 'KIOSK_ORDER') {
                  kiosk = type.amount
                }
                if (tp === 'TABLE_ORDER') {
                  table = type.amount
                }
                if (tp === 'TELEPHONE_ORDER') {
                  telephone = type.amount
                }
                if (tp === 'DELIVERY_APP_ORDER') {
                  deliveryApp = type.amount
                }
                if (tp === 'PARTNER_ORDER') {
                  partner = type.amount
                }
                if (tp === 'MOBILE_TABLE_ORDER') {
                  mobileTable = type.amount
                }
                if (tp === 'ETC_ORDER') {
                  etc = type.amount
                }
                sum += type.amount
              })

              statistics.push({
                date: period.date,
                pos: pos,
                kiosk: kiosk,
                table: table,
                telephone: telephone,
                deliveryApp: deliveryApp,
                partner: partner,
                mobileTable: mobileTable,
                etc: etc,
                sum: sum,
              })
            })
          }

          this.tableData = statistics
          this.$nextTick(
            function () {
              if (this.$refs.table) {
                this.$refs.table.doLayout()
              }
            }.bind(this)
          )
        }.bind(this),
        false
      )
    },
    getSummaries: function (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '합계'
          return
        }
        var values = data.map(function (item) {
          return Number(item[column.property])
        })
        if (
          !values.every(function (value) {
            return Number.isNaN(value)
          })
        ) {
          sums[index] = values
            .reduce(function (prev, curr) {
              return prev + curr
            }, 0)
            .toLocaleString()
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    downloadExcel: function () {
      if (!this.tableData || this.tableData.length === 0) {
        this.mainVue.$message({ type: 'warning', message: this.$t('데이타 없음') })
        return
      }

      var columns
      if (this.searchForm.periodTpVal === 'salesTp') {
        columns = [
          { header: '기간', key: 'date' },
          { header: '현금', key: 'cash' },
          { header: '카드', key: 'card' },
          { header: '포인트', key: 'point' },
          { header: '간편결제', key: 'easy' },
          { header: '온라인결제', key: 'online' },
          { header: '기타', key: 'etc' },
          { header: '합계', key: 'sum' },
        ]
      } else {
        columns = [
          { header: '기간', key: 'date' },
          { header: '포스 주문', key: 'pos' },
          { header: '키오스크 주문', key: 'kiosk' },
          { header: '테이블 주문', key: 'table' },
          { header: '전화 주문', key: 'telephone' },
          { header: '배달앱 주문', key: 'deliveryApp' },
          { header: '파트너 주문', key: 'partner' },
          { header: '모바일 테이블 주문', key: 'mobileTable' },
          { header: '기타', key: 'etc' },
          { header: '합계', key: 'sum' },
        ]
      }

      var headers = columns.map(function (c) {
        return c.header
      })
      var rows = this.tableData.map(function (row) {
        return columns.map(function (c) {
          return row[c.key] != null ? row[c.key] : 0
        })
      })

      var sumRow = columns.map(
        function (c, i) {
          if (i === 0) return '합계'
          return this.tableData.reduce(function (acc, row) {
            return acc + (Number(row[c.key]) || 0)
          }, 0)
        }.bind(this)
      )
      rows.push(sumRow)

      var ws = XLSX.utils.aoa_to_sheet([headers].concat(rows))
      var wb = XLSX.utils.book_new()

      var sheetName = this.searchForm.periodTpVal === 'salesTp' ? '결제수단' : '주문유형'
      XLSX.utils.book_append_sheet(wb, ws, sheetName)

      var fileName = '결제통계_' + sheetName + '_' + this.searchForm.startDt + '_' + this.searchForm.endDt + '.xlsx'
      XLSX.writeFile(wb, fileName)
    },
  },
}
</script>
